import { merge } from '../helper';

// ----------------------------------------------------------------------------

export type TypeEventDisabled = {
    merge?: any;
    parent: Node;
    fnAction: any;
    typeAction?: string;
};

function eventDisabled(element: HTMLElement, config: TypeEventDisabled): void {
    // Default Config
    const defConfig: Record<string, any> = {
        typeAction: 'mousedown',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // If there is parent and function action
    if (defConfig.parent instanceof HTMLElement && typeof defConfig.fnAction === 'function') {
        // Create event (disabled)
        defConfig.parent.addEventListener(defConfig.typeAction, function (evt): any {
            const res = defConfig.fnAction.call(this, element, evt);

            // If result is true, is disabled
            if (res === true) {
                element.setAttribute('disabled', '');
            }
            // If result is false, is not disabled
            else {
                element.removeAttribute('disabled');
            }
        });
    }
}

// ----------------------------------------------------------------------------

export default eventDisabled;
